import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../Modal/Modal";
import { setShowFeminicidios, selectShowFeminicidios, selectHurtoType, setHurtoType } from "../../redux/slices/filtersSlice";
import "./FiltersModal.css";

const FiltersModal = ({
  isVisible,
  onClose,
  dates,
  topN,
  comparisonYear,
  onApply,
  showFeminicidiosToggle,
  showHurtoTypeFilter = false
}) => {
  const dispatch = useDispatch();
  const showFeminicidios = useSelector(selectShowFeminicidios);
  const hurtoType = useSelector(selectHurtoType);

  // Estados temporales para validación
  const [tempDates, setTempDates] = useState({ start: "", end: "" });
  const [tempTopN, setTempTopN] = useState(10);
  const [tempComparisonYear, setTempComparisonYear] = useState(comparisonYear);
  const [error, setError] = useState("");

  // Sincronizar con props al abrir modal
  useEffect(() => {
    if (isVisible) {
      setTempDates(dates);
      setTempTopN(topN);
      setTempComparisonYear(comparisonYear);
      setError("");
    }
  }, [isVisible, dates, topN, comparisonYear]);

  const parseLocalDate = (str) => {
    const [y, m, d] = str.split("-").map(Number);
    return new Date(y, m - 1, d);
  };

  const validateDates = () => {
    if (!tempDates.start || !tempDates.end) {
      setError("Por favor, selecciona ambas fechas");
      return false;
    }

    const startDate = parseLocalDate(tempDates.start);
    const endDate = parseLocalDate(tempDates.end);
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();

    if (startYear !== endYear) {
      setError("Las fechas deben estar en el mismo año");
      return false;
    }

    if (startDate > endDate) {
      setError("La fecha inicial no puede ser mayor a la final");
      return false;
    }

    if (parseInt(tempComparisonYear) === startYear) {
      setError("El año de comparación no puede ser igual al año del rango de fechas");
      return false;
    }

    setError("");
    return true;
  };

  const handleApply = () => {
    if (!validateDates()) return;

    onApply(tempDates, tempTopN, parseInt(tempComparisonYear));
    onClose();
  };

  return (
    <Modal isVisible={isVisible} onClose={onClose}>
      <div className="filters-modal">
        <h2>Configurar Filtros</h2>

        {/* Rango de Fechas */}
        <div className="filters-section">
          <label>Rango de fechas:</label>
          <div className="filters-date-inputs">
            <div className="filters-date-input">
              <label>Inicio:</label>
              <input
                type="date"
                value={tempDates.start}
                onChange={(e) => setTempDates({ ...tempDates, start: e.target.value })}
              />
            </div>
            <div className="filters-date-input">
              <label>Fin:</label>
              <input
                type="date"
                value={tempDates.end}
                onChange={(e) => setTempDates({ ...tempDates, end: e.target.value })}
              />
            </div>
          </div>
        </div>

        {/* Año a Comparar */}
        <div className="filters-section">
          <label>Año a comparar:</label>
          <input
            type="number"
            min="2010"
            max="2026"
            value={tempComparisonYear}
            onChange={(e) => setTempComparisonYear(e.target.value)}
          />
        </div>

        {/* TopN */}
        <div className="filters-section">
          <label>Máximo de categorías por gráfico:</label>
          <input
            type="number"
            min="1"
            max="100"
            value={tempTopN}
            onChange={(e) => setTempTopN(parseInt(e.target.value) || 1)}
          />
        </div>

        {showFeminicidiosToggle && (
          <div className="filters-section">
            <label>Vista:</label>
            <select
              value={showFeminicidios ? "feminicidios" : "homicidios"}
              onChange={(e) => dispatch(setShowFeminicidios(e.target.value === "feminicidios"))}
            >
              <option value="homicidios">Homicidios</option>
              <option value="feminicidios">Feminicidios</option>
            </select>
          </div>
        )}

        {/* Tipo de Hurto (solo en /hurtos) */}
        {showHurtoTypeFilter && (
          <div className="filters-section">
            <label>Tipo de hurto:</label>
            <select
              value={hurtoType}
              onChange={(e) => dispatch(setHurtoType(e.target.value))}
            >
              <option value="Hurto de celular casos">Hurto de celular casos</option>
              <option value="Hurto de celular cantidad">Hurto de celular cantidad</option>
              <option value="Hurto a persona">Hurto a persona</option>
              <option value="Hurto a residencia">Hurto a residencia</option>
              <option value="Hurto a establecimiento comercial">Hurto a establecimiento comercial</option>
              <option value="Hurto de carro">Hurto de carro</option>
              <option value="Hurto de moto">Hurto de moto</option>
              <option value="Hurto de bicicleta cantidad">Hurto de bicicleta cantidad</option>
              <option value="Hurto de bicicleta casos">Hurto de bicicleta casos</option>
              <option value="Hurto a entidad financiera">Hurto a entidad financiera</option>
              <option value="Hurto por piratería terrestre">Hurto por piratería terrestre</option>
            </select>
          </div>
        )}

        {/* Mensaje de Error */}
        {error && <p className="filters-error">{error}</p>}

        {/* Botón Aplicar */}
        <button className="filters-apply-button" onClick={handleApply}>
          Aplicar Filtros
        </button>
      </div>
    </Modal>
  );
};

export default FiltersModal;
